export const MAX_REFETCH_INTERVAL = 30_000;
export const MIN_REFETCH_INTERVAL = 5_000;
export const HIGH_PROBABILITY_CHANCE = 90;
export const PROBABILITY_IMPACT_FACTOR = -281;
export const INITIAL_INTERVAL_MS = 30281;
export const JACKPOT_TYPE = 16;
export const SECONDS_TO_MILLISECONDS = 1_000;

export const COMPLETED_NO_WAGER_JACKPOTS_LS = 'completedNoWagerJackpots';
